import BaseButton from '../base-button';

import { TextFlavor } from './text-button';

export const Button = TextFlavor(BaseButton);